/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IGridRoom = Models.IGridRoom;
    import IGridPage = Models.IGridPage;
    import IGridMonitor = Models.IGridMonitor;
    import IMonitor = Models.IMonitor;
    import IMonitorHrefs = Models.IMonitorHrefs;
    import IAlarmsInfo = Models.IAlarmsInfo;
    import IBlock = Models.IBlock;
    

    export class GridController {
        public static $name: string = "gridController";
        public static $inject: string[] = ['$scope',
                                           '$q',
                                           'ModalService',
                                           'monitoringRoomService',
                                           'connectionRoomService',
                                           'sonAdapterService',
                                           '$cookies',
                                           '$timeout',
                                           '$document',
                                           '$window',
                                           'stompService',
                                           '$rootScope',
                                           '$location',
                                           'aclService',
                                           'messageTranslationsService',
                                           'userService',
                                           'alarmsService',
                                           'streamPipeService',
                                           'networkNodeService',
                                           'blockService'
                                           ];
        public static COOKIE_OPTIONS: ng.cookies.ICookiesOptions = 
                    { expires: Common.Utils.getCookieExpirationDate(), secure:  location.protocol === 'https:' };

        public editRoomMode: boolean;
        public firstAdjustmentDone: boolean;
        public userIsAdmin: boolean;
        public userIsRegularVnoUser: boolean;

        public columnsArray: number[];
        public rowsArray: number[];
        public currentPageIndex: number;

        private roomCookieKey: string = 'flex_grid_current_room';
        private pageCookieKey: string = 'flex_grid_current_page_';
        private rooms: IGridRoom[];
        private monitors: (IMonitor & {htmlId?: string})[][];
        private subscription: Services.IEventSubscription;
        private disabledModals: boolean = false;
        private userCanWriteRoom: boolean;
        private current: {
            room: IGridRoom,
            page: IGridPage,
            grid: Models.IMonitorPageGrid,
            monitorSize?: {
                width:  number,
                height: number,
            },
        };
        private sonServices: Models.ISwitch[];
        private firstLoad: boolean;
        private loading: boolean = false;
        private plotOptions: jquery.flot.plotOptions;

        constructor(private $scope: ng.IScope,
                    private qService: ng.IQService,
                    private modalService: ngModal.IModalService,
                    private monitoringRoomService: Services.MonitoringRoomService,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private sonService: Services.SonAdapterService,
                    private $cookies: ng.cookies.ICookiesService,
                    private $timeout: ng.ITimeoutService,
                    private $document: ng.IDocumentService,
                    private $window: ng.IWindowService,
                    private stompService: Services.StompService,
                    private $rootScope: Services.IFlexSettings,
                    private $location: ng.ILocationService,
                    private aclService: Services.AclService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private userService: Services.UserService,
                    private alarmsService: Services.AlarmsService,
                    private streamPipeService: Services.StreamPipeService,
                    private networkNodeService: Services.NetworkNodeService,
                    private blockService: Services.BlockService
        ) {
            this.firstAdjustmentDone = false;
            this.setUrlRoomAndPage();
            this.addListeners();
            this.init();

            this.$scope.$on("$destroy", function() { //removing url parameters on destroy
                $location.search('room', null);
                $location.search('page', null);
            });
        }

        public range(max: number): number[] {
            let range: number[] = [];
            for (let i: number = 0; i < max; i++) {
                range.push(i);
            }
            return range;
        }
	
	// TODO avoid calling this method from HTML
        public getRowStyle(): Object {
            let rows: number = this.current.page.rows;
            let columns: number = this.current.page.columns;
            let monitorMargin: number = 6;
            let aR: number = 16 / 9;

            let rowWidth: number;
            let rowHeight: number;

            let editionRowWidth: number = (this.editRoomMode === true) ? 25 + monitorMargin : 0;
            let editionRowHeight: number = (this.editRoomMode === true) ? 25 + monitorMargin : 0;

            let headHeight: number = 48 + 32;
            let viewWidth: number = $('#grid-monitors-container').width() - editionRowWidth;
            let viewHeight: number = $('.views-container').height() - headHeight - editionRowHeight * 2;
            if (!this.$rootScope.alarmConsoleHidden) {
                if (this.$rootScope.kiosk && this.current && this.current.room && this.current.room.alias) {
                    viewHeight -= 272;
                } else if (this.$rootScope.kiosk) {
                    viewHeight -= 230;
                } else {
                    viewHeight -= 280;
                }
            } else {
                if (!this.$rootScope.kiosk)
                    viewHeight -= 36;
            }

            let trendingHeight: number = (this.current.page.trending === true) ? this.calculateTrendingHeight() : 0;
            let rowLeftMargin: number = 0;
            // the spare space will be horizontal
            if (viewWidth * rows / (viewHeight - trendingHeight * rows) / columns > aR) {
                rowWidth = aR * columns * (viewHeight - trendingHeight * rows) / rows;
                rowHeight = viewHeight / rows;
                rowLeftMargin = (viewWidth - rowWidth) / 2;
            // the spare space will be vertical
            } else {
                rowWidth = viewWidth;
                rowHeight = trendingHeight + viewWidth / columns / aR;
            }

            // monitors adjustments
            $('.grid-monitor').css({
                'width': Math.floor((rowWidth - editionRowWidth - monitorMargin * (columns - 1)) / columns) + 'px',
            });

            for (let row of $('.uk-grid-row').toArray()) {
                $(row).find('.grid-monitor').not(':first').css('marginLeft', `${Math.floor(monitorMargin)}px`);
            }
            // edition row/column adjustments
            if (this.editRoomMode) {
                let monitorWidth: number = $('.grid-monitor').width();
                $('.grid-room-first-row').css('marginLeft', `${Math.floor(editionRowWidth + rowLeftMargin)}px`);
                $('.grid-room-first-row > div').css('marginLeft', `${Math.floor(monitorMargin)}px`);
                $('.grid-room-first-row > div').not(':last').css('width', `${Math.floor(monitorWidth)}px`);

                $('.grid-room-last-row').css('marginLeft', `${Math.floor(rowLeftMargin)}px`);
                $('.grid-switch-removal-icons').height(`${Math.floor($('.grid-monitor').height())}px`);

                if (monitorWidth < 100) {
                    $('.grid-edition-icon').css('fontSize', '22px');
                    $('.grid-add-icon').css('fontSize', '30px');
                } else {
                    $('.grid-edition-icon').css('fontSize', '40px');
                    $('.grid-add-icon').css('fontSize', '48px');
                }
            }
            return {
                'marginLeft': `${Math.floor(rowLeftMargin)}px`,
                'height': `${Math.floor(rowHeight)}px`,
                'width': `${Math.floor(rowWidth)}px`,
            };
        }

        public getCurrentPageIndex(): number {
            if (this.current && this.current.room && this.current.page && this.current.room.pages) {
                for (let i: number = 0; i < this.current.room.pages.length; i++) {
                    if (this.current.room.pages[i].id === this.current.page.id) {
                        this.currentPageIndex = i;
                        return i;
                    }
                }
            }
            this.currentPageIndex = 0;
            return 0;
        }

        public addElement(element: string): void {
            if (element === 'row') {
                this.monitoringRoomService.addRow(this.current.page.id).then((page: IGridPage) => {
                    for (let i: number = 0; i < this.current.room.pages.length; i++) {
                        if (page.id === this.current.room.pages[i].id) {
                            this.current.room.pages[i] = page;
                        }
                    }
                    this.current.page = page;
                    this.loadCurrentRoomGrid();
                });
            } else if (element === 'column') {
                this.monitoringRoomService.addColumn(this.current.page.id).then((page: IGridPage) => {
                    for (let i: number = 0; i < this.current.room.pages.length; i++) {
                        if (page.id === this.current.room.pages[i].id) {
                            this.current.room.pages[i] = page;
                        }
                    }
                    this.current.page = page;
                    this.loadCurrentRoomGrid();
                });
            } else if (element === 'page') {
                let numOrder: number;
                try {
                    numOrder = this.current.room.pages[this.current.room.pages.length - 1].numOrder + 1;
                } catch (ex) {
                    numOrder = 1;
                }
                this.monitoringRoomService.addMonitorPage(this.current.room.id, numOrder).then((p: IGridPage) => {
                    this.current.page = p;
                    this.putCookieVal(this.pageCookieKey + this.current.room.id, this.current.page.id);
                    this.loadRoomsAndGrid();
                });
            }
        }

        public changeTrending(): void {
            this.monitoringRoomService.toggleTrending(this.current.page.id).then((response: IGridPage) => {
                    this.current.page.trending = response.trending;
                    this.monitoringRoomService.notifyTrendingSwitch(Common.Utils.idFromHref(this.current.room.href), response.trending);
                });
        }

        public removeElement(element: string, elementIndex: number): void {
            if (element !== 'row' && element !== 'column' && element !== 'page')
                return;

            this.modalService.showModal({
                templateUrl: ConfirmModalController.templateURL,
                controller: ConfirmModalController.$name,
                inputs: {
                    title: `Remove ${ element }`,
                    description: `The ${ element } and all its monitors will be removed. This action cannot be undone.`,
                    name: '',
                    type: 'information',
                },
            })
            .then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(ConfirmModalController.ID,
                    {
                        bgclose: false,
                        modal: false,
                        keyboard: false,
                    });
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();

                    if (result) {
                        if (element === 'row') {
                            this.monitoringRoomService.removeRow(this.current.page.id, elementIndex).then((page: IGridPage) => {
                                for (let i: number = 0; i < this.current.room.pages.length; i++) {
                                    if (page.id === this.current.room.pages[i].id) {
                                        this.current.room.pages[i] = page;
                                    }
                                }
                                this.current.page = page;
                                this.loadCurrentRoomGrid();
                            });
                        } else if (element === 'column') {
                            this.monitoringRoomService.removeColumn(this.current.page.id, elementIndex).then((page: IGridPage) => {
                                for (let i: number = 0; i < this.current.room.pages.length; i++) {
                                    if (page.id === this.current.room.pages[i].id) {
                                        this.current.room.pages[i] = page;
                                    }
                                }
                                this.current.page = page;
                                this.loadCurrentRoomGrid();
                            });
                        } else {
                            this.monitoringRoomService.removeMonitorPage(this.current.page.id).then(() => {
                                this.current.room.pages = this.current.room.pages.filter((pg: IGridPage) =>
                                    pg.id !== this.current.page.id
                                );
                                this.changePage('prev');
                            });
                        }
                    }
                });
            });
        }

        public toggleEditRoomMode(): void {
            this.editRoomMode = !this.editRoomMode;
        }

        public changeRoom(newValue?: IGridRoom): void {
            this.current.room = newValue ? newValue : this.current.room;
            this.firstAdjustmentDone = false;
            this.putCookieVal(this.roomCookieKey, this.current.room.id);
            this.loading = true;
            this.loadRoomsAndGrid();
            this.getCurrentPageIndex();
        }

        /**
         * Changes the current page
         *
         * @param page string indicating the button that the user pressed to change the page
         */
        public changePage(page: string): void {
            this.getCurrentPageIndex();
            let pageIndex: number = 0;
            switch (page) {
                case 'first':
                    pageIndex = 0;
                    break;
                case 'prev':
                    pageIndex = this.current.room.pages[this.currentPageIndex - 1] ? this.currentPageIndex - 1 : 0;
                    break;
                case 'next':
                    pageIndex = this.current.room.pages[this.currentPageIndex + 1] ? this.currentPageIndex + 1 : this.current.room.pages.length - 1;
                    break;
                case 'last':
                    pageIndex = this.current.room.pages.length - 1;
                    break;
                default:
            }

            this.changePageByIndex(pageIndex);
        }

        /**
         * Changes the current page
         *
         * @param pageIndex index of new page
         */
        public changePageByIndex(pageIndex: number): void {

            let newPageIndex = this.normalizePageIndex(pageIndex);

            this.current.page = this.current.room.pages[newPageIndex];
            this.putCookieVal(this.pageCookieKey + this.current.room.id, this.current.page.id);
            this.updateUrl();
            this.monitors = [];
            this.getCurrentPageIndex();
            this.loadCurrentRoomGrid();
        }

        /**
         * Returns a valid page index based on the received parameter,
         * if the one received is out of bounds returns the nearest valid index (0 or the last index)
         *
         * @param pageIndex index of a page
         */
        public normalizePageIndex(pageIndex: number): number {
            let newPageIndex = pageIndex;

            if (newPageIndex < 0) {
                newPageIndex = 0;
            } else if (newPageIndex > this.current.room.pages.length - 1) {
                newPageIndex = this.current.room.pages.length - 1;
            }
            return newPageIndex;

        }

        public openGridMonitorSelectionModal(row: number, column: number): void {
            // disable modal click to avoid double modals issue FLEX-1566
            this.disabledModals = true;

            let currentMonitor: IGridMonitor = this.findMonitorByRowAndColumn(this.current.grid.monitorPage.monitors, row, column);
            this.openGridMonitorSelectionModalHelper(currentMonitor, row, column);

        }

        public aclMRModal(): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.AclModalController.templateURL,
                controller: Application.Controllers.AclModalController.$name,
                inputs: {
                    entity: this.current.room,
                    entityTypeName: 'monitorRooms',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.AclModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    modalElem.hide();
                });
            });
        }


        public removalGridMonitorModal(row: number, column: number): void {
            this.modalService.showModal({
                templateUrl: ConfirmModalController.templateURL,
                controller: ConfirmModalController.$name,
                inputs: {
                    title: `Remove the monitor`,
                    description: `This action cannot be undone.`,
                    name: '',
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let promptModalElem: UIkit.ModalElement = UIkit.modal(ConfirmModalController.ID,
                    {
                        bgclose: false,
                        modal: false,
                        keyboard: false,
                    });
                promptModalElem.show();
                modal.close.then((result: Object) => {
                    promptModalElem.hide();
                    if (result) {
                        this.monitoringRoomService
                            .removeGridStream(this.current.page.id,
                                              this.findMonitorByRowAndColumn(this.current.grid.monitorPage.monitors, row, column))
                            .then(() => {
                                // do nothing
                            })
                            .catch(() => {
                                this.loadRoomsAndGrid();
                            });
                        let i: number = this.findPageIndexById(this.current.room.pages, this.current.page.id);
                        if (i !== undefined) {
                            let j: number = this.findMonitorIndexByRowAndColumn(this.current.room.pages[i].monitors, row, column);
                            if (j !== undefined) this.current.room.pages[i].monitors.splice(j, 1);
                        }
                        i = this.findMonitorIndexByRowAndColumn(this.current.page.monitors, row, column);
                        if (i !== undefined) this.current.page.monitors.splice(i, 1);
                        i = this.findMonitorIndexByRowAndColumn(this.current.grid.monitorPage.monitors, row, column);
                        if (i !== undefined) this.current.grid.monitorPage.monitors.splice(i, 1);
                        this.mapMonitors();
                    }
                });
            });
        }

        public createMRModal(): void {
            const name: string = 'Name';
            const alias: string = 'Alias';
            const inputs: IGenericMultipleModalInputsMap = {};
            inputs[name] = {
                required: true,
                value: '',
            };
            inputs[alias] = {
                required: false,
                value: '',
            };
            this.modalService.showModal({
                templateUrl: GenericMultipleModalController.templateUrl,
                controller: GenericMultipleModalController.$name,
                inputs: {
                    title: 'Create grid room',
                    description: '',
                    inputs: inputs,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(GenericMultipleModalController.id,
                                                                      { bgclose: false, modal: false, keyboard: false });
                modalElem.show();
                modal.close.then((result: IGenericMultipleModalResultsMap) => {
                    modalElem.hide();
                    if (result) {
                        this.createMonitoringRoom(result[name], result[alias]);
                    }
                });
            });
        }

        public editMRModal(): void {
            const name: string = 'Name';
            const alias: string = 'Alias';
            const inputs: IGenericMultipleModalInputsMap = {};
            inputs[name] = {
                required: true,
                value: this.current.room.name,
            };
            inputs[alias] = {
                required: false,
                value: this.current.room.alias,
            };
            this.modalService.showModal({
                templateUrl: GenericMultipleModalController.templateUrl,
                controller: GenericMultipleModalController.$name,
                inputs: {
                    title: 'Edit grid room',
                    description: '',
                    inputs: inputs,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(GenericMultipleModalController.id,
                                                                { bgclose: false, modal: false, keyboard: false });
                modalElem.show();
                modal.close.then((result: IGenericMultipleModalResultsMap) => {
                    modalElem.hide();
                    if (result) {
                        this.current.room.name = result[name] ? result[name] : this.current.room.name;
                        this.current.room.alias = result[alias];
                        this.saveMonitoringRoom();
                    }
                });
            });
        }


        /**
         * Modal to delete the selected connection room
         */
        public deleteMRModal(): void {
            this.modalService.showModal({
                templateUrl: ConfirmModalController.templateURL,
                controller: ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE GRID ROOM',
                    description: 'This action cannot be undone.',
                    name: this.current.room.name,
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                    { bgclose: false, modal: false, keyboard: false });
                modalElem.show();
                modal.close.then((result: string) => {
                    modalElem.hide();
                    if (result) {
                        this.deleteMonitoringRoom();
                    }
                });
            });
        }

        public getGridMonitorId(row: number, column: number): string {
            return `${this.current.room.id}_${this.current.page.id}_${row}_${column}`;
        }

        private openGridMonitorSelectionModalHelper(/*res: [Models.IBlock[], Models.IBlock[], Models.ISwitch[]],*/
                                                    currentMonitor: IGridMonitor,
                                                    row: number, column: number): void {
            this.modalService.showModal({
                templateUrl: GridStreamSelectionModalController.templateUrl,
                controller: GridStreamSelectionModalController.$name,
                inputs: {
                    currentMonitor: currentMonitor,
                },
            }).then((modal: ngModal.IModalObject) => {
                let promptModalElem: UIkit.ModalElement = UIkit.modal(GridStreamSelectionModalController.id,
                    {
                        bgclose: false,
                        modal: false,
                        keyboard: false,
                    });
                promptModalElem.show();
                modal.close.then((result: {
                    tx: number,
                    rx: number,
                    currentMonitor: IGridMonitor,
                    type: 'Video' | 'SwitchPort',
                }) => {

                    promptModalElem.hide();
                    if (result !== undefined) {
                        if (result.currentMonitor) {
                            this.monitoringRoomService.updateGridStream(this.current.page.id, row, column, result.tx, result.rx,
                                result.currentMonitor, result.type).then(() => {
                                this.loadRoomsAndGrid();
                            });
                        } else {
                            this.monitoringRoomService.addGridStream(this.current.page.id, row, column, result.tx, result.rx,
                                result.type).then(() => {
                                this.loadRoomsAndGrid();
                            });
                        }

                    }
                    
                    this.$timeout(() => {
                        this.disabledModals = false;
                    }, 800);
                });
            });
        }

        private findPageIndexById(pages: IGridPage[], id: number): number {
            if (pages !== undefined && pages.length > 0) {
                for (let i: number = 0; i < pages.length; i++) {
                    if (pages[i].id === id) {
                        return i;
                    }
                }
            }
            return undefined;
        }

        private findMonitorIndexByRowAndColumn(monitors: IGridMonitor[], row: number, column: number): number {
            if (monitors !== undefined && monitors.length > 0) {
                for (let i: number = 0; i < monitors.length; i++) {
                    if (monitors[i].row === row && monitors[i].column === column) {
                        return i;
                    }
                }
            }
            return undefined;
        }

        private findMonitorByRowAndColumn(monitors: IGridMonitor[], row: number, column: number): IGridMonitor {
            for (let monitor of monitors) {
                if (monitor.row === row && monitor.column === column) {
                    return monitor;
                }
            }
            return undefined;
        }

        private async loadRoomsAndGrid(): Promise<void> {
            // loading the rooms
            const rooms: IGridRoom[] = await this.monitoringRoomService.getAllGridRooms();
            // this.sonServices = await this.sonService.getSonServices();
            if (rooms !== undefined && rooms.length > 0) {
                this.rooms = Common.Utils.orderArrayByKey(rooms, 'name');
                this.updateCurrentRoom();
                await this.loadCurrentRoomPages();
                await this.loadCurrentRoomGrid();
                this.addElementsOnFirstLoad();
                await this.getMonitorRoomPerm();
                this.getCurrentPageIndex();
                this.updateUrl();
            }
        }

        private updateUrl(): void {
            let params = this.$location.search();
            params.room = this.current.room.id;
            params.page = this.current.page.id;
            this.$location.search(params);
        }

        private addListeners(): void {

            let w: JQuery = angular.element(this.$window);
            w.on('popstate', (event) => {
                let roomParam: number = parseInt(this.$location.search().room, 10);
                let pageParam: number = parseInt(this.$location.search().page, 10);

                if(!isNaN(roomParam) && roomParam !== this.current.room.id) {
                    const filteredRooms = this.rooms.filter((room) => room.id === roomParam);
                    let newRoom = filteredRooms.length > 0 ? filteredRooms[0] : this.current.room;
                    this.changeRoom(newRoom);
                }

                if(!isNaN(pageParam) && pageParam !== this.current.page.id) {
                    const filteredPages = this.current.room.pages.filter((page) => page.id === pageParam);
                    let pageIndex = this.current.room.pages.indexOf(filteredPages.length > 0 ? filteredPages[0] : this.current.page);
                    this.changePageByIndex(pageIndex)
                }
            });

        }

        private async getMonitorRoomPerm(): Promise<void> {
            if(!this.userCanWriteRoom){
            this.userCanWriteRoom = await this.aclService.canWrite("monitorRooms", this.current.room.id);
           }
        }

        private async loadCurrentRoomPages(): Promise<void> {
            let currentPageId: number = this.getCookieVal(this.pageCookieKey + this.current.room.id);
            const pages: IGridPage[] = await this.monitoringRoomService.getAllGridPagesByRoomId(this.current.room.id);
            if (pages !== undefined && pages.length > 0) {
                if (currentPageId !== undefined) {
                    this.current.page = undefined;
                    for (let page of pages) {
                        if (page.id === currentPageId) {
                            this.current.page = page;
                        }
                    }
                }
                if (currentPageId === undefined || this.current.page === undefined) {
                    this.current.page = pages[0];
                    this.putCookieVal(this.pageCookieKey + this.current.room.id, this.current.page.id);
                }
            }
            this.current.room.pages = pages;
        }

        private updateCurrentRoom(): void {
            let currentRoomId: number = this.getCookieVal(this.roomCookieKey);
            if (currentRoomId !== undefined) {
                for (let room of this.rooms) {
                    if (room.id === currentRoomId) {
                        this.current.room = room;
                    }
                }
            }
            if (currentRoomId === undefined || this.current.room === undefined) {
                this.current.room = this.rooms[0];
                this.putCookieVal(this.roomCookieKey, this.current.room.id);
            }
        }

        private addElementsOnFirstLoad(): void {
            if (this.firstLoad && this.rooms.length < 2) {
                if (this.current.room === this.rooms[0] && this.current.room.pages.length < 1) {
                    this.addElement('page');
                }
                this.firstLoad = false;
            }
        }

        private async init(): Promise<void> {
            this.editRoomMode = false;
            this.current = { room: undefined, page: undefined, grid: undefined };
            this.firstLoad = true;

            this.plotOptions = {
                grid: {
                    hoverable: false,
                    clickable: false,
                    autoHighlight: false,
                    backgroundColor: '#333',
                    markings: [],
                },
            };
            
            await this.loadRoomsAndGrid();
            this.registerStompServices();
            const user: Models.IUser = await this.userService.loadCurrentUser();
            this.userIsAdmin = user.authorities.some((auth: Models.IAuthority) => {
                return auth.authority === 'ROLE_ADMIN';
            });
            this.userIsRegularVnoUser = this.userService.userIsRegularVnoUser();
        }

        private registerStompServices(): void {
            this.subscription = this.stompService.register(Models.FLEXO_COMPONENT, Models.ALL_OPERATIONS,
                (flexEvent: Models.IFlexEvent) => {
                    if (flexEvent.operation === Models.SAVE_STREAM_PIPE_OPERATION ||
                        flexEvent.operation === Models.DELETE_STREAM_PIPE_OPERATION) {
                        for (let i: number = 0; i < this.monitors.length; i++) {
                            for (let j: number = 0; j < this.monitors[i].length; j++) {
                                if (this.monitors[i][j] &&
                                    (flexEvent.data.sink === this.monitors[i][j].monitorGrid.source ||
                                     flexEvent.data.sink === this.monitors[i][j].monitorGrid.sink ||
                                     flexEvent.data.source === this.monitors[i][j].monitorGrid.source ||
                                     flexEvent.data.source === this.monitors[i][j].monitorGrid.sink)) {
                                        this.updateMonitor(i, j);
                                    }
                            }
                        }
                    } else if (flexEvent.operation === Models.DELETE_BLOCK_OPERATION) {
                        for (let i: number = 0; i < this.monitors.length; i++) {
                            for (let j: number = 0; j < this.monitors[i].length; j++) {
                                if (this.monitors[i][j] &&
                                    (flexEvent.data.id === this.monitors[i][j].monitorGrid.source ||
                                        flexEvent.data.id === this.monitors[i][j].monitorGrid.sink)) {
                                    this.loadRoomsAndGrid();
                                }
                            }
                        }
                    }
                });

            this.$scope.$on('$destroy', () => {
                if (this.subscription) {
                    this.stompService.unregister(this.subscription);
                }
            });
            this.$rootScope.$on('timezoneChanged',()=>{
                this.loading = true;
                this.$timeout(()=>{
                    this.loading = false
                },0);
            })
        }

        private async loadCurrentRoomGrid(): Promise<void> {
            if (this.current.page !== undefined) {
                this.columnsArray = this.range(this.current.page.columns);
                this.rowsArray = this.range(this.current.page.rows);

                this.current.grid = await this.monitoringRoomService.getMonitorPageGridByPageId(this.current.page.id);
                this.mapMonitors();

            }
        }

        private updateMonitor(row: number, column: number): void {
            if (this.current.page !== undefined) {
                this.monitoringRoomService.getMonitorPageGridByPageId(this.current.page.id).then(
                    (grid: Models.IMonitorPageGrid) => {
                        for (let monitor of grid.monitorPage.monitors) {
                            if (monitor.row === row && monitor.column === column) {
                                let i: number = this.findMonitorIndexByRowAndColumn(this.current.grid.monitorPage.monitors, row, column);
                                let newMonitor: IMonitor & {htmlId?: string} = new Models.Monitor();
                                newMonitor.monitorGrid = this.current.grid.monitorPage.monitors[i];
                                newMonitor.monitorRoom = this.current.room.href;
                                newMonitor.name = `${monitor.sourceName ? monitor.sourceName : ''} 
                                                   ${monitor.sourceName && monitor.sinkName ? '>' : ''} 
                                                   ${monitor.sinkName ? monitor.sinkName : ''}`;
                                newMonitor.totalMonitorInRoom = grid.monitorPage.monitors.length;
                                try {
                                    let key: string = 'href';
                                    newMonitor.source = grid.streamPipesMap[monitor.id].links[0][key];
                                } catch (e) {
                                    //
                                }
                                newMonitor.htmlId = this.getGridMonitorId(row, column);
                                this.monitors[row][column] = newMonitor;
                            }
                        }
                    });
            }
        }

        private getCookieVal(cookieKey: string): number {
            let val: string = this.$cookies.get(cookieKey);
            return (val) ? parseInt(val, 10) : undefined;
        }

        private putCookieVal(cookieKey: string, val: number): number {
            this.$cookies.put(cookieKey, val.toString(), GridController.COOKIE_OPTIONS);
            return val;
        }

        private async mapMonitors(): Promise<void> {
            this.monitors = [];
            for (let i: number = 0; i < this.current.grid.monitorPage.rows; i++) {
                this.monitors.push([]);
            }
            let multiviewerRoomBlockSinkIds: number[] = this.current.grid.monitorPage.monitors.map((monitor: IGridMonitor) => Number(monitor.sink));
            let multiviewerRoomBlockSinkBlocks: IBlock[] = await this.blockService.getAllMultiviewerRoomBlocks(multiviewerRoomBlockSinkIds);
            for (let gridMonitor of this.current.grid.monitorPage.monitors) {
                let monitor: IMonitor & {htmlId?: string} = new Models.Monitor();
                monitor.id = gridMonitor.id;
                monitor.htmlId = this.getGridMonitorId(gridMonitor.row, gridMonitor.column);
                if (this.current.grid.streamPipesMap[gridMonitor.id] !== undefined) {
                    let key: string = 'href';
                    monitor.source = this.current.grid.streamPipesMap[gridMonitor.id].links[0][key];
                    monitor.streamPipe = this.current.grid.streamPipesMap[gridMonitor.id];
                }
                if (gridMonitor.type === 'Video') {
                    monitor.name = gridMonitor.sourceName ? gridMonitor.sourceName : '';
                    monitor.name += (gridMonitor.sourceName && gridMonitor.sinkName) ? ' > ' : '';
                    monitor.name += gridMonitor.sinkName ? gridMonitor.sinkName : '';
                } else {
                    gridMonitor.sourceName = "";
                    // this.getSwitchPortMonitorName(gridMonitor);
                }
                monitor.totalMonitorInRoom = this.current.grid.monitorPage.monitors.length;
                this.monitors[gridMonitor.row][gridMonitor.column] = monitor;
                this.monitors[gridMonitor.row][gridMonitor.column].monitorGrid = gridMonitor;
                this.monitors[gridMonitor.row][gridMonitor.column].monitorGrid.sinkBlock = this.findBlockInfo(Number(gridMonitor.sink), multiviewerRoomBlockSinkBlocks);
            }

            this.loading = false;
            this.loadAlarmsInfo();
            this.$timeout(() => {
                this.firstAdjustmentDone = true;
            }, 1);
        }

        public findBlockInfo(blockId: number, allBlocks: IBlock[]): IBlock{
            let blockFound;
            allBlocks.forEach( (block: IBlock)=>{
                if(block.id == blockId){
                    blockFound = block;
                    return;
                }
            });
            return blockFound;
        }

        public async getBlockInfo(sinksList: number[]){
            return await this.blockService.getAllBlocksPromise().then( (res: IBlock[]) => {
                return res.filter((block: IBlock) => {
                    return sinksList.some((sinkId)=>{
                        return sinkId == block.id;
                    })
                });
            });
        }

        private async loadAlarmsInfo(): Promise<void>  {
            let monitorCoords: [number, number][] = [];
            let hrefsList: IMonitorHrefs[] = [];
            for (const monitorRow of this.monitors) {
                for (const monitor of monitorRow) {
                    if (monitor) {
                        const hrefs: IMonitorHrefs = await this.getBlocksSimplifiedHref(monitor);
                        hrefsList.push(hrefs);
                        monitorCoords.push([monitor.monitorGrid.row, monitor.monitorGrid.column]);
                    }
                }
            }
            let alarmsInfo: IAlarmsInfo[][] = await this.alarmsService.getAlarmsInfoForListOfMonitorHrefs(hrefsList);
            alarmsInfo.forEach((monitorAlarms: IAlarmsInfo[], index: number) => {
                let [row, column]: [number, number] = monitorCoords[index];
                this.processMonitorAlarms(this.monitors[row][column], monitorAlarms);
            });
        }

        private async getBlocksSimplifiedHref(monitor: IMonitor): Promise<IMonitorHrefs> {
            let baseHref: string = 'networkNodes/';
            let baseHrefBlocks: string = 'blocks/';
            let srcHref: string = undefined;
            let srcBlockHref: string = undefined;
            let srtHrefs: string[] = [];
            let srtBlockHrefs: string[] = [];
            if (monitor.streamPipe && (monitor.monitorGrid.sink || (monitor.monitorGrid.source && monitor.monitorGrid.sink))) {
                const links: string = 'links';
                const href: string = 'href';
                monitor.streamPipe.href = monitor.streamPipe[links][0][href];
                const allSrtHrefs: string[] = await this.streamPipeService.getSrtInPipe(monitor.streamPipe);
                allSrtHrefs.forEach((srtHref: string) => {
                    if (srtHref.indexOf(baseHref) > -1) {
                        srtHrefs.push(srtHref);
                    } else {
                        srtBlockHrefs.push(srtHref);
                    }
                });
            }
            if (monitor.streamPipe && monitor.streamPipe.sourceBlockId) {
                srcBlockHref = baseHrefBlocks + monitor.streamPipe.sourceBlockId;
                srcHref = baseHref + monitor.streamPipe.sourceNodeHref;
            } else if (monitor && monitor.monitorGrid && !!monitor.monitorGrid.source) {
                srcBlockHref = baseHrefBlocks + monitor.monitorGrid.source;
                srcHref = baseHref + monitor.monitorGrid.sourceNode;
            }
            return {
                srcBlockHref: srcBlockHref,
                sinkBlockHref: baseHrefBlocks + monitor.monitorGrid.sink,
                srcHref: srcHref,
                sinkHref: baseHref + monitor.monitorGrid.sinkNode,
                extraBlockHrefs: srtBlockHrefs,
                extraHrefs: srtHrefs,
            };

        }

        private processMonitorAlarms(monitor: IMonitor, monitorAlarms: IAlarmsInfo[]): void {
            if (!monitor.alarmsInfo) {
                monitor.alarmsInfo = {
                    currentCriticals: [],
                    allCount: 0,
                    criticalsCount: 0,
                    showAllAlarms: false,
                    showCriticalAlarms: false,
                };
            }
            for (let monitorAlarm of monitorAlarms) {
                // we don't want the red frame if there is not a stream active
                if (this.current.grid.streamPipesMap[monitor.id]) {
                    let currentAlarms: Models.IAlarm[] = monitorAlarm.currentAlarms;
                    for (let alarm of currentAlarms) {
                        if (!alarm.confirmed && !alarm.masked && (alarm.level === 0 || alarm.level === 8)) {
                            monitor.alarmsInfo.currentCriticals.push({
                                alarmName: alarm.name,
                                deviceSimplifiedHref: alarm.deviceId,
                            });
                        }
                    }
                }
                monitor.alarmsInfo.allCount += monitorAlarm.allNonHidden;
                monitor.alarmsInfo.criticalsCount += monitorAlarm.criticalNonHidden;
            }
            monitor.alarmsInfo.showAllAlarms =
                monitor.alarmsInfo.allCount > 0 &&
                monitor.alarmsInfo.criticalsCount > 0 &&
                monitor.alarmsInfo.currentCriticals.length > 0 &&
                !!this.current.grid.streamPipesMap[monitor.id];
            monitor.alarmsInfo.showCriticalAlarms =
                monitor.alarmsInfo.criticalsCount > 0 &&
                monitor.alarmsInfo.currentCriticals.length > 0 &&
                !!this.current.grid.streamPipesMap[monitor.id];
        }

        private getSwitchPortMonitorName(monitorGrid: IGridMonitor): string {
            if (!this.sonServices)
                return "Service no longer available";

            const monitorSwitches: Models.ISwitch[] =  this.sonServices.filter( (switchElement: Models.ISwitch) => {
                return switchElement.id === monitorGrid.sink;
            });

            return monitorSwitches.length > 0 ? monitorSwitches[0].name : "Service no longer available";
        }

        private createMonitoringRoom(name: string, alias: string): void {
            let newRoom: IGridRoom = Models.GridRoom.Empty();
            newRoom.name = name;
            newRoom.alias = alias;
            this.monitoringRoomService.saveMonitoringRoom(newRoom as Models.MonitoringRoom)
                .then((element: Models.IMonitoringRoom) => {
                    (element as IGridRoom).id = Common.Utils.idFromHref(element.href);
                    if (this.rooms === undefined)
                        this.rooms = [element as IGridRoom];
                    else
                        this.rooms.push(element as IGridRoom);
                    this.current.room = element as IGridRoom;
                    this.changeRoom();
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                })
                .finally(() => {
                    this.loadRoomsAndGrid();
                });
        }

        private saveMonitoringRoom(): void {
            this.monitoringRoomService.saveMonitoringRoom(this.current.room as Models.IMonitoringRoom)
                .then((monitoringRoom: Models.IMonitoringRoom) => {
                    for (let i: number = 0; i < this.rooms.length; i++)
                        if (this.rooms[i].href === monitoringRoom.href)
                            this.rooms[i].name = monitoringRoom.name;
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                })
                .finally(() => {
                    this.loadRoomsAndGrid();
                });
        }

        private deleteMonitoringRoom(): void {
            this.monitoringRoomService.deleteMonitoringRoom(this.current.room as Models.IMonitoringRoom)
                .then(() => {
                    this.rooms = this.rooms.filter((room: IGridRoom) => room.id !== this.current.room.id);
                    this.current.room = this.rooms[0];
                    this.changeRoom();
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                });
        }

        private setUrlRoomAndPage(): void {
            let kioskRoom: number = parseInt(this.$location.search().room, 10);
            let kioskPage: number = parseInt(this.$location.search().page, 10);
            if (Common.Utils.exists(kioskRoom) && !isNaN(kioskRoom)) {
                this.putCookieVal(this.roomCookieKey, kioskRoom);
                if (Common.Utils.exists(kioskPage)) {
                    this.putCookieVal(this.pageCookieKey + kioskRoom, kioskPage);
                }
            } else if (Common.Utils.exists(kioskPage)) {
                this.$location.search('page', undefined);
            }
        }

        private calculateTrendingHeight(): number {
            let monHeight: number =  $('.grid-monitor').first() ? $('.grid-monitor').first().height() : 0;
            return Math.floor(monHeight  / 3) ;

        }
    }
}